// src/main.js

import '@/assets/scss/main.scss'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router' // Auto-imports from /router/index.js
//import createPinia from 'pinia'

// Create and mount the app
const app = createApp(App)

app.use(router) // Register the router
//app.use(createPinia)

app.mount('#app')